import React, { useState } from "react";
import cx from "classnames";

import CallbackModal from "../../../../../common/components/Modals/CallbackModal/CallbackModal";
import Icon from "../../../../../common/components/Icon/Icon";

interface IQuoteTableRightFitCard {
    isOverviewText?: boolean;
    className?: string;
}

const QuoteTableRightFitCard: React.FC<IQuoteTableRightFitCard> = (props) => {
    const { isOverviewText, className } = props;

    const [isOpenCallback, setIsOpenCallback] = useState(false);

    return (
        <div
            className={cx(
                {
                    [className]: !!className,
                    "height-full": isOverviewText,
                    "layout-flex-column--justify-centered": isOverviewText
                },
                "layout-flex-column--centered",
                "text-align--center"
            )}>
            <CallbackModal
                isOpen={isOpenCallback}
                onClose={() => setIsOpenCallback(false)}
            />
            {!isOverviewText && (
                <React.Fragment>
                    <img
                        src="../../../../images/illustrations/not-the-right-fit.svg"
                        className={cx("margin-vertical-l figure")}
                    />
                    <h4 className="gap-m">Not the right fit?</h4>
                </React.Fragment>
            )}

            <p className="text-font-size-s">
                We&apos;ve got more options up our sleeve if these options don&apos;t fit.{" "}
                <a onClick={() => setIsOpenCallback(true)}>Get in touch.</a>
            </p>
            {!isOverviewText && (
                <div className={cx("layout-flex-row", "width-full")}>
                    <a href="tel:0800800400" className={cx("width-full", "text-primary")}>
                        <Icon id={"HelpPhone"} size="4xl" />
                        <p className={cx("text-small")}>Call</p>
                    </a>

                    <a
                        onClick={() => setIsOpenCallback(true)}
                        className={cx("width-full", "text-primary")}>
                        <Icon id={"Callback"} size="4xl" />
                        <p className={cx("text-small")}>Contact</p>
                    </a>
                </div>
            )}
        </div>
    );
};

export default QuoteTableRightFitCard;
